<template>
  <div id="app">
    <!-- <navbarHeader v-if="(path !== '/index' && path !== '/ComingSoon')"></navbarHeader> -->
    <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <div class="Backtotop" v-if="Backtotop" @click="toTop"><img src="@/assets/Backtotop.png" alt=""></div>
    <div v-if="(path === '/index' || path === '/orderList' || path === '/classify' || path === '/ShoppingCart')">
      <div v-if="path==='/index'">
          <div :class="GooShow?'Go':'GoRight'" @touchstart="enter">
            <div class="GooDpi" style="background:rgba(45,199,140,1);" @click="bat()">
              <img src="@/assets/fen.png" alt="">
            </div>
            <div class="GooDpi" style="background:rgba(240,206,85,1);" @click="btn()">
              <img src="@/assets/ding.png" alt="">
            </div>
          </div>
      </div>
      <div v-else-if="path==='/orderList'">
          <div :class="GooShow?'Go':'GoRight'" @touchstart="enter">
            <div class="GooDpi" style="background:rgba(191,164,253,1);" @click="atn()">
              <img src="@/assets/shou.png" alt="" >
            </div>
            <div class="GooDpi" style="background:rgba(45,199,140,1);" @click="bat()">
              <img src="@/assets/fen.png" alt="">
            </div>
          </div>
      </div>
      <div v-else>
          <div :class="GooShow?'Go':'GoRight'" @touchstart="enter">
            <div class="GooDpi" style="background:rgba(191,164,253,1);" @click="atn()">
              <img src="@/assets/shou.png" alt="" >
            </div>
            <div class="GooDpi" style="background:rgba(240,206,85,1);" @click="btn()">
              <img src="@/assets/ding.png" alt="">
            </div>
          </div>
      </div>
    </div>
    <div v-if="(path === '/index' || path === '/orderList' || path === '/classify' || path === '/ShoppingCart')">
      <div v-if="path!=='/ShoppingCart'" :class="GooShow?'ShoppingCart':'ShoppingCartRight'" @touchstart="enter" >
        <div @click="GoShoppingCart" style="background:rgba(255,166,83,1);">
          <img src="@/assets/gou.png" alt="">
        </div>
      </div>
      <div v-else :class="GooShow?'Shoppingfen':'ShoppingfenRight'" @touchstart="enter" >
        <div @click="bat" style="background:rgba(45,199,140,1);">
          <img src="@/assets/fen.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import navbarHeader from './components/navbarHeader'
// var a = 0
export default {
  name: 'App',
  data () {
    return {
      path: '',
      GooShow: true,
      showIndex: true,
      setTimeout: '',
      Backtotop: false
    }
  },
  components: {
    // navbarHeader
  },
  created () {
    localStorage.removeItem('good_id')
    var _that = this
    this.setTimeout = setTimeout(() => {
      _that.GooShow = false
    }, 15000)
  },
  // 路径
  mounted () {
    this.path = this.$route.path
    window.addEventListener('scroll', this.showbtn, true)
  },
  methods: {
    enter() {
      var _this = this
      window.clearTimeout(this.setTimeout)
      _this.GooShow = true
      this.setTimeout = setTimeout(() => {
        _this.GooShow = false
      }, 15000)
      // _isMobile() {
      // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // return flag;
    //   if (this._isMobile()) {
    //   alert("手机端");
    //   this.$router.replace('/m_index');
    // } else {
    //   alert("pc端");
    //   this.$router.replace('/pc_index');
    // }
    // }
    },
    showbtn() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 1545) {
        this.Backtotop = true
      } else {
        this.Backtotop = false
      }
    },
    // 返回顶部
    toTop() {
      // 方法1
      // document.documentElement.scrollTop = 0
      // 方法2
      var timer = setInterval(function() {
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        const ispeed = Math.floor(-scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = scrollTop + ispeed
        if (scrollTop === 0) {
          clearInterval(timer)
        }
      }, 20)
    },
    // 订单
    btn() {
      // this.GooShow = true
      if (this.showIndex && this.GooShow) {
        console.log(this.showIndex, this.GooShow)
        console.log('展开')
        this.showIndex = false
        return false
      }
      if (this.showIndex === false && this.GooShow) {
        console.log('跳转')
        this.showIndex = true
        this.$router.push('/orderList')
        return false
      }
    },
    // 分类
    bat() {
      if (this.showIndex && this.GooShow) {
        console.log('展开')
        this.showIndex = false
        return false
      }
      if (this.showIndex === false && this.GooShow) {
        console.log('跳转')
        this.showIndex = true
        this.$router.push('/classify')
        return false
      }
    },
    atn() {
      if (this.showIndex && this.GooShow) {
        console.log('展开')
        this.showIndex = false
        return false
      }
      if (this.showIndex === false && this.GooShow) {
        console.log('跳转')
        this.showIndex = true
        this.$router.push('/index')
        return false
      }
    },
    GoShoppingCart() {
      if (this.showIndex && this.GooShow) {
        console.log('展开')
        this.showIndex = false
        return false
      }
      if (this.showIndex === false && this.GooShow) {
        console.log('跳转')
        this.showIndex = true
        this.$router.push('/ShoppingCart')
        return false
      }
    }
  },
  watch: {
    $route (to, from) {
      if (to.path !== this.path) {
        this.showIndex = true
        this.GooShow = false
        window.clearTimeout(this.setTimeout)
      }
      this.path = to.path
      if (to.path !== '/index') {
        window.scrollTo(0, 0)
        document.getElementsByTagName('body')[0].className = 'home'
        document.getElementsByTagName('html')[0].className = 'home'
        document.getElementById('app').className = 'home'
      } else {
        document.getElementsByTagName('body')[0].className = ''
        document.getElementsByTagName('html')[0].className = ''
        document.getElementById('app').className = ''
      }
    }
  }
}
</script>

<style lang="less">
.home{
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    -webkit-user-select:none ;
    -moz-user-select:none;
}
#app,body,html {
    width: 100%;
    margin: 0;
    padding: 0;
    -webkit-user-select:none ;
    -moz-user-select:none;
}
input{
    -webkit-appearance: none;
    outline: none;
    -webkit-tap-heighlight-color:rgba(0,0,0,0);
}
*{
  margin: 0;
  padding: 0;
}
li {
  list-style: none;
}
.Go{
  width: 100px;
  height: 235px;
  position: fixed;
  right: 0;
  top: 800px;
}
.GoRight{
  width: 100px;
  height: 235px;
  position: fixed;
  right: -50px;
  top: 800px;
}
.GooDpi{
  width: 100px;
  height: 100px;
  box-shadow:2px 2px 35px 0px rgba(0, 0, 0, 0.2);
  border-radius:50%;
  position: relative;
  margin-bottom: 30px;
  img{
    width: 39px;
    height: 63px;
    position: absolute;
    top: 18px;
    left: 30px;
  }
}
.ShoppingCart{
  position: fixed;
  right: 0;
  top: 1060px;
  width: 100px;
  height: 100px;
  box-shadow:2px 2px 35px 0px rgba(0, 0, 0, 0.2);
  border-radius:50%;
    div{
    width: 100%;
    height: 100%;
    border-radius:50%;
      img{
      width: 59px;
      height: 66px;
      position: absolute;
      top: 18px;
      left: 20px;
    }
  }
}
.ShoppingCartRight{
  position: fixed;
  right: -50px;
  top: 1060px;
  width: 100px;
  height: 100px;
  box-shadow:2px 2px 35px 0px rgba(0, 0, 0, 0.2);
  border-radius:50%;
  div{
    width: 100%;
    height: 100%;
    border-radius:50%;
    img{
      width: 59px;
      height: 66px;
      position: absolute;
      top: 18px;
      left: 20px;
    }
  }
}
.Shoppingfen{
  position: fixed;
  right: 0;
  top: 1060px;
  width: 100px;
  height: 100px;
  box-shadow:2px 2px 35px 0px rgba(0, 0, 0, 0.2);
  border-radius:50%;
    div{
    width: 100%;
    height: 100%;
    border-radius: 50%;
      img{
        width: 39px;
        height: 63px;
        position: absolute;
        top: 18px;
        left: 30px;
      }
  }
}
.ShoppingfenRight{
  position: fixed;
  right: -50px;
  top: 1060px;
  width: 100px;
  height: 100px;
  box-shadow:2px 2px 35px 0px rgba(0, 0, 0, 0.2);
  border-radius:50%;
  div{
    width: 100%;
    height: 100%;
    border-radius: 50%;
    img{
      width: 39px;
      height: 63px;
      position: absolute;
      top: 18px;
      left: 30px;
    }
  }
}
// .AppmarginTop {
//   margin-top: 80px;
// }
.van-toast{
  width: 280px !important;
  line-height: 40px !important;
}
.van-toast__text {
  font-size: 30px;
  padding: 20px;
}
.van-dialog {
  width: 480px !important;
}
.van-dialog__message {
  font-size: 30px !important;
  // padding: 0px 1px !important;
  color: #666666 !important;
  line-height: 45px;
}
.van-button {
  font-size: 32px !important;
}
.van-button--large {
  height: 80px !important;
  line-height: 80px !important;
}
.van-loading__text {
  font-size: 27px !important;
}
.van-toast__icon{
  font-size: 55px !important;
}
.van-picker__cancel, .van-picker__confirm{
  font-size: 34px !important;
}
.van-picker__toolbar{
  padding-top: 20px;
}
.van-picker-column {
  font-size: 32px !important;
}
.van-address-edit__buttons{
  padding-top: 50px !important;
}
.van-address-edit__buttons .van-button {
  height: 80px !important;
}
.van-address-edit__buttons .van-button--round {
  border-radius: 0px !important;
}
.van-list__finished-text{
  font-size: 26px !important;
}
.van-image-preview__index{
  font-size: 28px !important;
}
.van-dialog__header--isolated {
  font-size: 30px !important;
  padding: 50px 0px;
}
.Backtotop{
  position: fixed;
  right: 50px;
  top: 1000px;
  z-index: 999;
  img{
    width: 109px;
    height: 109px;
  }
}
// .van-image-preview{
//   position: fixed;
//   top: 0 !important;
//   left: 0 !important;
//   bottom: 0 !important;
//   right: 0 !important;
//   width: 100% !important;
//   height: 100% !important;
// }
// .van-overlay{
//   position: fixed;
//     top: 0 !important;
//     left: 0 !important;
//     width: 100% !important;
//     height: 100% !important;
//     bottom: 0 !important;
//     right: 0 !important;
// }

</style>
